import Button from "@shared/v2/Button";
import ProductCard from "./ProductCard";
import TextButton from "@shared/v2/TextButton";
import Typography from "@shared/v2/Typography";
import { ProductFamilyIds } from "./constants";
import { Product } from "../Support/Account/AddOnsSupport/types";

interface Step2Props {
  product: Product;
  onBack: () => void;
  onNext: () => void;
}

const Step2: React.FC<Step2Props> = ({ onBack, onNext, product }) => (
  <>
    <div className="tw-flex tw-gap-[40px]">
      <div className="tw-flex tw-flex-col tw-gap-[16px] tw-flex-1 tw-basis-4/12">
        {/* @ts-expect-error props */}
        <Typography variant="subtitle-m">Your Selected Plan:</Typography>
        <ProductCard product={product} />
      </div>
      <div className="tw-min-h-full tw-border-solid tw-border-[1px] tw-border-gray-5" />
      <div className="tw-flex tw-flex-col tw-gap-[16px] tw-flex-1 tw-basis-6/12">
        {/* @ts-expect-error props */}
        <Typography variant="subtitle-m">Subscription Overview</Typography>
        <div className="tw-shadow-card tw-rounded-[8px] tw-px-[24px] tw-py-[16px] tw-flex tw-flex-col tw-gap-[16px] tw-border-solid tw-border-[1px] tw-border-gray-10">
          <div className="tw-flex tw-justify-between">
            <span>{product.name}</span>
            <span className="tw-font-semibold">${product.details.unitPrice.toFixed(2)}</span>
          </div>
          {/* <div className="tw-flex tw-justify-between">
            <span>Taxes & Fees</span>
            <span className="tw-font-semibold">${(plan.details.unitPrice * 0.1).toFixed(2)}</span>
          </div> */}
          <div className="tw-bg-gray-5 tw-h-[1px] tw-w-full" />
          <div className="tw-flex tw-flex-col">
            <div className="tw-flex tw-justify-between">
              <span className="tw-font-bold">Total due on your next CRM bill date*</span>
              <span className="tw-text-18d tw-font-bold">${product.details.unitPrice.toFixed(2)}</span>
            </div>
            {product.slug.startsWith(ProductFamilyIds.PhoneSystem) && (
              <span className="tw-text-12d tw-text-gray-50">
                Additional overages may apply based on usage
              </span>
            )}
          </div>
        </div>
        <span className="tw-text-12d tw-text-gray-50 tw-text-right">
          *Monthly amount will be billed to the same payment method you use to pay for CRM. You will be
          charged a pro-rated amount for the first month up until your regularly scheduled Brivity Platform
          recurring monthly billing date.
        </span>
      </div>
    </div>
    <div className="tw-flex tw-justify-between tw-items-center">
      {onBack ? (
        // @ts-expect-error props
        <TextButton size="medium" onClick={onBack}>
          Pick a Different Plan
        </TextButton>
      ) : (
        <div />
      )}
      {/* @ts-expect-error props */}
      <Button size="medium" onClick={onNext}>
        Next
      </Button>
    </div>
  </>
);

export default Step2;
